module.exports = __webpack_public_path__ + "static/img/img.99b16b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_us/img.png
// module id = cmbf
// module chunks = 0